import { useFormikContext } from "formik";
import { isEmpty } from "lodash-es";
import { Alert, AlertList, AlertWrapper } from "melco-ui";
import { useTranslation } from "react-i18next"

export const DisplayCustomHoopFormErrors: React.FC = () => {

    const { t } = useTranslation();
    const { status } = useFormikContext();

    if (!status || isEmpty(status.errorMessages)) {
        return null
    }

    return (<>
        <AlertWrapper>
            <Alert
                message={t('global.error.form.title')}
                type="error"
                withBackground
                description={<>{
                    !isEmpty(status.globalErrorMessages) && (
                        <AlertList >
                            {
                                status.globalErrorMessages.map((error: string) => (
                                    <li key={error}>{error}</li>
                                ))
                            }
                        </AlertList>
                    )
                }
                    {
                        !isEmpty(status.fieldErrorMessages) && (
                            <AlertList >
                                {status.fieldErrorMessages?.product_list?.[0] &&
                                    <li key={status.fieldErrorMessages?.product_list?.[0]}>
                                        {status.fieldErrorMessages?.product_list?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.category_list?.[0] &&
                                    <li key={status.fieldErrorMessages?.category_list?.[0]}>
                                        {status.fieldErrorMessages?.category_list?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.machine_list?.[0] &&
                                    <li key={status.fieldErrorMessages?.machine_list?.[0]}>
                                        {status.fieldErrorMessages?.machine_list?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.asset?.[0] &&
                                    <li key={status.fieldErrorMessages?.asset?.[0]}>
                                        {status.fieldErrorMessages?.asset?.[0]}
                                    </li>
                                }
                                {status.fieldErrorMessages?.id?.[0] &&
                                    <li key={status.fieldErrorMessages?.id?.[0]}>
                                        {status.fieldErrorMessages?.id?.[0]}
                                    </li>
                                }
                            </AlertList>
                        )
                    }
                </>
                }
            />
        </AlertWrapper>
    </>)
}